function Cyber() {
  return (
    <>

      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb7">
        <div className="bg-breadcrumb-single" />
        <div className="container text-center py-5" style={{ maxWidth: 900 }}>
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Cyber Security
          </h4>

        </div>
      </div>
      {/* START PORTFOLIO */}
      <div className="container">
        <section className="portfolio section-padding" id="portfolio">
          <div className="row">
            <div className="section-title  wow zoomIn">
              <div className="indented">
                <h2>Cyber Security Solutions to Protect Your Digital Assets</h2>
                <p>
                  In today’s digital landscape, robust cybersecurity is essential for
                  safeguarding sensitive data and ensuring business continuity. Our{" "}
                  <strong>Cybersecurity Services</strong> offer end-to-end protection
                  for your IT infrastructure, designed to prevent, detect, and respond
                  to evolving cyber threats. With our expert guidance and advanced
                  security solutions, organizations can minimize risk, achieve
                  compliance, and maintain customer trust.
                </p><br></br>
                {/* <div className="text-center">
                      <img style={{width:1200, height: 600}} src="assets/img/Picture1.png" alt="LPG Sales" className="img-fluid rounded shadow mt-3" />
                    </div> */}
                <div className="text-center cyber-image-wrapper">
                  <img
                    src="assets/img/Picture1.png"
                    alt="Cyber Security Overview"
                    className="cyber-large-image rounded shadow mt-3"
                  />
                </div>
                <br></br><br></br>
                <h3>Our Cybersecurity Service Offerings</h3>
                <ol>
                  <li>
                    Security Assessment and Risk Management
                    <ul style={{ padding: 0.1 % 1 % 1 % 1, fontWeight: 400 }}>
                      <li>
                        Comprehensive security assessments to identify vulnerabilities
                        and potential security gaps.
                      </li>
                      <li>
                        Risk management solutions to prioritize threats and implement
                        strategic mitigation plans.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Threat Detection and Incident Response{" "}
                    <ul style={{ padding: 0.1 % 1 % 1 % 1, fontWeight: 400 }}>
                      <li>
                        Real-time monitoring and threat detection for early
                        identification of suspicious activities.
                      </li>
                      <li>
                        Rapid incident response services to contain and neutralize
                        threats before they impact your operations.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Network Security and Firewall Management{" "}
                    <ul style={{ padding: 0.1 % 1 % 1 % 1, fontWeight: 400 }}>
                      <li>
                        Advanced network security solutions, including firewalls,
                        intrusion detection, and intrusion prevention systems.
                      </li>
                      <li>
                        Regular monitoring and updates to protect against unauthorized
                        access and external threats.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Endpoint Protection and Device Security
                    <ul style={{ padding: 0.1 % 1 % 1 % 1, fontWeight: 400 }}>
                      <li>
                        Endpoint security solutions to secure devices, from laptops to
                        mobile devices, against malware and unauthorized access.
                      </li>
                      <li>
                        Centralized management of endpoint security policies for
                        consistent, organization-wide protection.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Identity and Access Management (IAM){" "}
                    <ul style={{ padding: 0.1 % 1 % 1 % 1, fontWeight: 400 }}>
                      <li>
                        Multi-factor authentication, role-based access controls, and
                        single sign-on (SSO) solutions to safeguard user identity.
                      </li>
                      <li>
                        Robust access management to enforce least privilege and
                        protect sensitive data.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Cloud Security Solutions
                    <ul style={{ padding: 0.1 % 1 % 1 % 1, fontWeight: 400 }}>
                      <li>
                        Secure cloud infrastructure to protect data and applications
                        in cloud environments, ensuring compliance with industry
                        standards.
                      </li>
                      <li>
                        Continuous monitoring and management of cloud security to
                        prevent data leaks and unauthorized access.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Compliance and Regulatory Support
                    <ul style={{ padding: 0.1 % 1 % 1 % 1, fontWeight: 400 }}>
                      <li>
                        Assistance with meeting industry compliance standards like
                        GDPR, HIPAA, PCI-DSS, and ISO.
                      </li>
                      <li>
                        Documentation, reporting, and security audits to ensure
                        ongoing regulatory alignment.
                      </li>
                    </ul>
                  </li>
                </ol>
                <h3>Why Choose Our Cybersecurity Services?</h3>
                <ul style={{ marginBottom: -10, padding: 0 % 1 % 1 % 1, fontWeight: 400 }}>
                  <li style={{ lineHeight: 1.1 }}>
                    Consultants trained and experienced in all Cyber Security Services{" "}
                  </li>
                  <li style={{ lineHeight: 1.1 }}>
                    Experienced resources, Mix of technical and functional profiles
                  </li>
                  <li style={{ lineHeight: 1.1 }}>External attack measures</li>
                  <li style={{ lineHeight: 1.1 }}>Internal fraud measures for Business-Specific Solutions</li>
                  <li style={{ lineHeight: 1.1 }}>VPN and Cloud Security Connectivity</li>

                  <li style={{ lineHeight: 1.1 }}>
                    <strong>Certified Cybersecurity Experts</strong>: A team of
                    certified professionals with expertise in the latest cybersecurity
                    frameworks and practices.
                  </li>
                  <li style={{ lineHeight: 1.1 }}>
                    <strong>Customized Solutions</strong>: Tailored cybersecurity
                    strategies that align with your unique business requirements and
                    risk profile.
                  </li>
                  <li style={{ lineHeight: 1.1 }}>
                    <strong>Proactive Protection</strong>: Advanced threat
                    intelligence and real-time monitoring to stay ahead of emerging
                    threats.
                  </li>
                </ul>
                {/* <p>
            Our Cybersecurity solutions offer comprehensive protection, enabling
            you to focus on your core business with the confidence that your
            digital assets are secure.{" "} */}
                {/* <a href="index.html#contact">Contact Us</a> today to strengthen your
            cybersecurity defenses and secure a safer future for your
            organization. */}
                {/* </p> */}
              </div>
            </div>
          </div>
          {/* <section className="portfolio section-padding" id="portfolio"> */}
          {/* <div className="row">
        <div className="section-title  wow zoomIn">
          <div className="indented">
            <section>
              <h2>Security Operations Center (SOC/NOC) as a Service</h2>
              <p>
                Protect your organization from evolving cyber threats with our{" "}
                <strong>Security Operations Center (SOC/NOC)</strong> as a
                Service. Our SOC/NOC solutions provide around-the-clock
                monitoring, advanced threat detection, and rapid incident
                response to safeguard your digital assets and ensure compliance
                with industry standards. By leveraging the latest in
                cybersecurity technology, we offer scalable and cost-effective
                protection tailored to meet the demands of modern IT
                infrastructure.
              </p>
              <h3>Our SOC/NOC Service Offerings</h3>
              <ol>
                <li>
                  Continuous Threat Monitoring and Detection
                  <ul>
                    <li>
                      24/7 real-time monitoring of your systems and networks to
                      identify potential threats.
                    </li>
                    <li>
                      Advanced threat intelligence tools to detect suspicious
                      activities and anomalies.
                    </li>
                  </ul>
                </li>
                <li>
                  Incident Response and Remediation
                  <ul>
                    <li>
                      Swift response to security incidents to contain and
                      eliminate threats.
                    </li>
                    <li>
                      Comprehensive investigation and root cause analysis to
                      prevent future breaches.
                    </li>
                  </ul>
                </li>
                <li>
                  Vulnerability Management and Risk Assessment
                  <ul>
                    <li>
                      Regular vulnerability scans and assessments to identify
                      security gaps.
                    </li>
                    <li>
                      Prioritization and mitigation recommendations to minimize
                      risk exposure.
                    </li>
                  </ul>
                </li>
                <li>
                  Managed SIEM (Security Information and Event Management)
                  <ul>
                    <li>
                      Collection, analysis, and correlation of security events
                      across your environment.
                    </li>
                    <li>
                      Actionable insights provided through a centralized
                      dashboard for proactive security management.
                    </li>
                  </ul>
                </li>
                <li>
                  Endpoint Detection and Response (EDR)
                  <ul>
                    <li>
                      Endpoint security solutions to detect, investigate, and
                      respond to threats on devices.
                    </li>
                    <li>
                      Enhanced endpoint visibility and control, minimizing the
                      risk of compromise.
                    </li>
                  </ul>
                </li>
                <li>
                  Compliance and Reporting
                  <ul>
                    <li>
                      Ensure alignment with regulatory standards like GDPR,
                      HIPAA, and ISO.
                    </li>
                    <li>
                      Detailed security reports and dashboards for audits and
                      compliance tracking.
                    </li>
                  </ul>
                </li>
              </ol>
              <h3>Why Choose Our SOC/NOC as a Service?</h3>
              <ul>
              <li>
                <strong>Expert Cybersecurity Team</strong>: Certified security
                analysts with years of experience in threat management.
              </li>
              <li>
                <strong>Advanced Threat Intelligence</strong>: Leverage
                up-to-date threat intelligence to stay ahead of emerging risks.
              </li>
              <li>
                <strong>Scalable Solutions</strong>: Customized SOC/NOC
                solutions that grow with your business needs.
              </li>
              <li>
                <strong>Cost-Efficient</strong>: Reduce the expense of building
                and maintaining an in-house SOC/NOC.
              </li>
              </ul>
              <p>
                Our SOC/NOC as a Service empowers you to focus on your business,
                knowing that your systems, data, and users are secure.{" "}
                <a href="index.html#contact">Contact Us</a> today to discover
                how our SOC/NOC solutions can enhance your security posture and
                resilience.
              </p>
              <h3>Benefits of outsourcing security functions to a SOC/NOC</h3>
              <ol>
                <li>
                  24/7 Monitoring and Rapid Incident Response
                  <ul>
                    <li>
                      SOC/NOC providers offer round-the-clock security
                      monitoring, ensuring that potential threats are detected
                      immediately, even after business hours.
                    </li>
                    <li>
                      Immediate incident response from trained security experts
                      reduces the time from detection to resolution, minimizing
                      damage and downtime.
                    </li>
                  </ul>
                </li>
                <li>
                  Access to Advanced Security Tools and Expertise
                  <ul>
                    <li>
                      SOC/NOC providers bring specialized expertise and tools
                      for threat detection, analysis, and response, which can be
                      cost-prohibitive for in-house setups.
                    </li>
                    <li>
                      Outsourced SOC/NOCs employ certified analysts who stay
                      current with the latest cyber threats and mitigation
                      techniques, bringing unparalleled expertise to your
                      security efforts.
                    </li>
                  </ul>
                </li>
                <li>
                  Cost Savings and Resource Efficiency
                  <ul>
                    <li>
                      Outsourcing eliminates the costs of recruiting, training,
                      and retaining an in-house security team, along with
                      purchasing and maintaining advanced tools.
                    </li>
                    <li>
                      SOC/NOC as a Service models offer scalable pricing,
                      allowing companies to pay only for the level of service
                      they need, making it ideal for organizations of any size.
                    </li>
                  </ul>
                </li>
                <li>
                  Enhanced Threat Intelligence
                  <ul>
                    <li>
                      Outsourced SOC/NOCs aggregate threat intelligence from
                      multiple clients, providing deeper insights into emerging
                      trends and enabling proactive security measures.
                    </li>
                    <li>
                      By leveraging shared knowledge and real-time threat
                      intelligence, SOC/NOC providers can quickly identify
                      patterns, allowing for faster prevention and response.
                    </li>
                  </ul>
                </li>
                <li>
                  Improved Compliance and Reporting
                  <ul>
                    <li>
                      SOC/NOC providers assist in maintaining compliance with
                      industry regulations and standards such as GDPR, HIPAA,
                      PCI-DSS, and ISO.
                    </li>
                    <li>
                      Comprehensive reporting and logging ensure that your
                      organization is audit-ready, with accurate documentation
                      and insight into security practices.
                    </li>
                  </ul>
                </li>
                <li>
                  Scalability and Flexibility
                  <ul>
                    <li>
                      SOC/NOC as a Service can easily scale with business
                      growth, adapting to the changing security needs of the
                      organization.
                    </li>
                    <li>
                      As your company expands or as regulatory requirements
                      evolve, SOC/NOC providers can adjust services to meet
                      increased demand or new compliance needs.
                    </li>
                  </ul>
                </li>
                <li>
                  Focus on Core Business Functions
                  <ul>
                    <li>
                      By outsourcing security functions, internal teams can
                      focus on core business initiatives without being bogged
                      down by time-consuming security management.
                    </li>
                    <li>
                      Reduced burden on IT and management staff allows for
                      greater productivity in other critical areas of the
                      business.
                    </li>
                  </ul>
                </li>
              </ol>
              <p>
                Outsourcing to a SOC/NOC provides robust protection while
                reducing the complexity and cost of managing security in-house,
                allowing businesses to stay secure, compliant, and focused on
                growth.
              </p>
            </section>
            
          </div>
        </div>
      </div> */}
          {/* </section> */}
          {/* <div className="text-center">
                      <img style={{width:1200, height: 600}} src="assets/img/Picture2.jpg" alt="LPG Sales" className="img-fluid rounded shadow mt-3" />
                    </div> */}
          <div className="text-center cyber-image-wrapper">
            <img
              src="assets/img/Picture2.jpg"
              alt="Cyber Security Overview"
              className="cyber-large-image rounded shadow mt-3"
            />
          </div>
        </section>
      </div>

      <div className="container">
        <section className="portfolio section-padding" id="portfolio">

          <div className="row">
            <div className="section-title wow zoomIn">
              <div className="indented">


                <section className="wow fadeInUp" data-wow-delay="0.3s">





                  <div className="row align-items-center mb-5">
                    <div className="col-lg-7">
                      <h5>The Reality of Modern Cyber Threats</h5>
                      <p>It’s no longer a matter of if but when your organization will face a cyberattack. Cybercrime does not discriminate—businesses of every size and industry are targeted.</p>
                      <p>Modern attackers rely heavily on techniques like phishing, which fuel most breaches. They exploit both people and systems to gain access to valuable data and financial assets. Even a single attack can lead to costly disruption, with financial damage often ranging from hundreds to tens of thousands of dollars.</p>
                      <p>As cyber threats continue to escalate, maintaining vigilance and strengthening cybersecurity defenses is essential for protecting operations, reputation, and the bottom line.</p>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/cyberpic1.png"
                        alt="Infrastructure Assessment"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "350px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>

                  {/* 2 */}
                  <div className="row align-items-center mb-5 flex-lg-row-reverse">
                    <div className="col-lg-7">
                      <h5>Beyond the Ransom: The True Cost of Cyber Attacks</h5>
                      <p>Cyberattacks go far beyond the ransom payment itself. They can halt business operations, trigger regulatory consequences, and generate a wide range of hidden financial burdens. Organizations may be forced to absorb direct and indirect impacts such as:</p>
                      <ul>
                        <li>
                          Lost client and revenue opportunities
                        </li>
                        <li>
                          Costs associated with incident response and damage mitigation
                        </li>
                        <li>Increased cybersecurity insurance premiums</li>
                        <li>	Hardware and software repair or replacement</li>
                        <li>	Loss of buyer and investor trust</li>
                        <li>	Long-term reputational harm</li>
                      </ul>
                      <p>The aftershocks of a cyber incident can ripple through every area of the organization—affecting finances, credibility, and growth for months or even years.</p>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/cyberpic2.png"
                        alt="Cloud Infrastructure"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "450px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>

                  {/* 3 */}
                  <div className="row align-items-center mb-5">
                    <p>Our Virtual CISO offers comprehensive security leadership, combining strategic oversight with hands-on protection across your entire technology landscape. Key services include:</p>
                    <div className="col-lg-7">

                      <h5>Security Strategy & Governance</h5>
                      <ul>
                        <li>
                          Identity Governance & Administration (IGA)
                        </li>
                        <li>
                          Zero Trust Networks / SASE / Secure Web Gateway
                        </li>
                        <li>	Audit support & continuous compliance</li>
                        <li>	Cloud, infrastructure & perimeter security</li>
                      </ul>
                      <h5>Threat Prevention & Protection</h5>
                      <ul>
                        <li>Modern Endpoint Security</li>
                        <li>	Mobile Device Management (MDM)</li>
                        <li>	Advanced email filtering</li>
                        <li>Data Loss Prevention (DLP)</li>
                        <li>Web Application Firewalls & CDN</li>
                        <li>	Multi-Factor Authentication & Single Sign-On</li>
                        <li>	Managed network device security</li>
                      </ul>
                      <h5>Risk Management & Resilience</h5>
                      <ul>
                        <li>	Vulnerability assessments & penetration testing</li>
                        <li>  Patch management & configuration hardening</li>
                        <li>	Backup & business continuity readiness</li>
                      </ul>
                      <h5>Security Culture & Awareness</h5>
                      <ul>
                        <li>	Continuous user security awareness training</li>
                      </ul>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/cyberpic3.png"
                        alt="Data Center"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "400px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>

                  {/* 4 */}
                  <div className="row align-items-center mb-5 flex-lg-row-reverse">
                    <div className="col-lg-7">
                      <h5>SIEM & SOC: Unified Cyber Defense</h5>
                      <p>Most security tools operate in silos, making it difficult to see the full threat picture. A Security Information and Event Management (SIEM), centralizes data from across the organization and analyzes it against real-time threat intelligence — enabling quick, informed response.</p>
                      <p>A 24/7 Security Operations Center (SOC) continuously monitors the entire environment, detecting attacks as they happen and ensuring threats are contained before they cause damage.</p>
                      <p>Together, SIEM + SOC deliver:</p>
                      <ul>
                        <li>
                          Complete visibility into security activity
                        </li>
                        <li>
                          Faster detection and response
                        </li>
                        <li>	Around-the-clock protection</li>
                        <li>	Ongoing reporting and compliance readiness</li>
                      </ul>
                    </div>
                    <div className="col-lg-5 text-center">
                      <img
                        src="assets/img/cyberpic4.png"
                        alt="Network Infrastructure"
                        className="img-fluid rounded-4 shadow"
                        style={{ height: "400px", width: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </div>
                </section>




              </div>
            </div>
          </div>
        </section>
      </div>



      {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
            {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                    className="border-bottom text-primary"
                    href="https://htmlcodex.com"
                >
                    HTML Codex
                </a>{" "}
                Distributed By{" "}
                <a
                    className="border-bottom text-primary"
                    href="https://themewagon.com"
                >
                    ThemeWagon
                </a>


              </div> */}
          </div>
        </div>
      </div>
      {/* <a href="/Cyber" className="btn btn-primary btn-lg-square back-to-top">
          <i className="fa fa-arrow-up" />
        </a> */}

      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>



    </>

  );
};

export default Cyber